var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyWatchlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My Watchlist"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5789 4.60156H1C0.447715 4.60156 0 5.04928 0 5.60156V5.70683C0 6.25911 0.447715 6.70683 1 6.70683H10.5789C11.1312 6.70683 11.5789 6.25911 11.5789 5.70683V5.60156C11.5789 5.04928 11.1312 4.60156 10.5789 4.60156Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5789 0.391113H1C0.447715 0.391113 0 0.838829 0 1.39111V1.49638C0 2.04866 0.447715 2.49638 1 2.49638H10.5789C11.1312 2.49638 11.5789 2.04866 11.5789 1.49638V1.39111C11.5789 0.838829 11.1312 0.391113 10.5789 0.391113Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.36842 8.81201H1C0.447715 8.81201 0 9.25973 0 9.81201V9.91727C0 10.4696 0.447715 10.9173 1 10.9173H6.36842C6.92071 10.9173 7.36842 10.4696 7.36842 9.91727V9.81201C7.36842 9.25973 6.92071 8.81201 6.36842 8.81201Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check",
    d: "M10 9.60889L12.2857 11.6089L18 6.60889",
    stroke: "#5E5E5E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyWatchlist);
export default __webpack_public_path__ + "static/media/MyWatchlist.a08db569059cd50a26a4a23e258dc0a7.svg";
export { ForwardRef as ReactComponent };